export default {
    "hotelData": [{
            id: 1,
            tourImage: 'hotel1',
            altText: "image",
            location: 'New beach, Thailand',
            tourTitle: 'Kantua hotel, Thailand',
            reviewRating: '4.8/5 Excellent',
            reviewCount: '1214 reviewes',
            price: '$99.00',
            startForm: 'Price starts from'
        },
        {
            id: 2,
            tourImage: 'hotel2',
            altText: "image",
            location: 'Indonesia',
            tourTitle: 'Hotel paradise international',
            reviewRating: '4.8/5 Excellent',
            reviewCount: '1214 reviewes',
            price: '$99.00',
            startForm: 'Price starts from'
        },
    ],
}